<template>
  <div class="bief-infroduction">
    <div class="infroduction">
      <div class="infroduction-content">
        <div class="title-wrap">
          <div class="title">华跃科技</div>
          <div class="line"></div>
        </div>
        <div class="describe" v-html="describe">
          <!-- {{ describe }} -->
        </div>
        <div class="data-list">
          <div
            v-for="(item, index) in enterpriseData"
            :key="index"
            class="data-item"
          >
            <div class="data-content">
              <div class="data-wrap">
                <div class="data-value">{{ item.data }}</div>
                <div class="plus-company-wrap">
                  <div v-if="item.plus" class="plus">+</div>
                  <div class="company">{{ item.company }}</div>
                </div>
              </div>
              <div class="data-text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="introduce-video-wrap">
      <vue-core-video-player
        :src="require('@/assets/about/infroduction/introduce.mp4')"
        autoplay
      />
    </div>
    <div class="company-characteristic">
      <div class="title">为企业创造更大的价值，让客户感动</div>
      <div class="characteristic-wrap">
        <div
          v-for="(item, index) in characteristicList"
          :key="index"
          :style="{ background: characteristicIndex === index ? `url('${item.onBackImg}') no-repeat` : `url('${item.backImg}') no-repeat` }"
          class="characteristic-item"
          :class="{'is-enter': characteristicIndex === index}"
          @mouseenter="onMouseenter(index)"
          @mouseleave="onMouseleave"
        >
          <div class="content-wrap">
            <div class="item-content">
              <div class="item-title">
                {{ item.title }}
              </div>
              <div class="item-text">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';
export default {
  name: 'InfroductionView',
  data () {
    return {
      describe: '',
      enterpriseData: [
        // {
        //   text: '更新迭代，紧跟潮流',
        //   data: 8,
        //   plus: false,
        //   company: '代',
        // },
        // {
        //   text: '知名企业所选用并得到广泛赞誉',
        //   data: 50,
        //   plus: true,
        //   company: '家',
        // },
        // {
        //   text: '华南市场占有率',
        //   data: 36,
        //   plus: false,
        //   company: '%',
        // },
        // {
        //   text: 'eHR系统研发与销售',
        //   data: 16,
        //   plus: false,
        //   company: '年',
        // },
      ],
      playerOptions: {
        height: '528',
        sources: [
          {
            type: 'video/mp4',
            src: 'rtmp://58.200.131.2:1935/livetv/hunantv',
          },
        ],
      },
      characteristicIndex: null,
      characteristicList: [
        // {
        //   title: '专业高效的服务团队',
        //   text: '公司吸引了一大批技术、市场与管理精英加入，拥有一支专业高效的服务团队，为每一位客户提供专业的“顾问式服务”。16年来，华跃科技没有一家因无法满足其需求而放弃合作的客户，也没有一家客户对我们的服务不满意，连续多年被评为“优质服务供应商”。我们已经在eHR领域开创出了属于自己的优秀品牌。',
        //   backImg: require('@/assets/about/infroduction/characteristic1.png'),
        //   onBackImg: require('@/assets/about/infroduction/characteristic-back1.png'),
        // },
        // {
        //   title: '与多家知名企业合作',
        //   text: '多年来，华跃eHR系统被美的、格力、科龙、TCL、浦项制铁、松下、万家乐、南方风机、华兴玻璃、广船国际、科勒、顺纺集团、南海公安等知名企业所选用并得到广泛赞誉，目前在华南市场的占有率已经达到了36%。',
        //   backImg: require('@/assets/about/infroduction/characteristic2.png'),
        //   onBackImg: require('@/assets/about/infroduction/characteristic-back2.png'),
        // },
        // {
        //   title: '紧跟时代潮流',
        //   text: '华跃经典产品HUAYUE eHR V3.0，凭借华跃科技多年来专注于eHR行业的沉淀与创新，为广大客户提供了高质量的信息化服务。最新一代华跃企业云eHR信息管理系统V8.0，紧跟时代潮流，在系统架构、云计算、大数据处理、稳定性、易用性均取得飞跃性突破，更加适用于企业愈来愈复杂的组织架构管理，并更加注重在“培养人才”上为企业提供更丰富全面的管理支持。凭借在行业的16年优质服务、专业的产品方案优势，相信与华跃的合作将是您一个理想的选择！',
        //   backImg: require('@/assets/about/infroduction/characteristic3.png'),
        //   onBackImg: require('@/assets/about/infroduction/characteristic-back3.png'),
        // },
      ],
    };
  },
  mounted() {
    this.getPageColumn();
  },
  methods: {
    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1608278223798624256', };
      getColumnChild(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '华跃科技') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentDoc = new DOMParser().parseFromString(content, 'text/html');
              this.describe = contentDoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // var describe = rrsult.elements.find(obj => obj.name === 'describe').content;
              // this.describe = describe;
            });
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var enterprise = {
                  text: rrsult.data[j].title,
                  data: rrsult.data[j].summaryTitle,
                  plus: false,
                  company: rrsult.data[j].description,
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var plus = rtsult.elements.find(obj => obj.name === 'plus').content;
                enterprise.plus = JSON.parse(plus);
                this.enterpriseData.push(enterprise);
              }
            });
          } else if (result[i].name === '更大的价值') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 10, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var characteristic = {
                  title: rrsult.data[j].title,
                  text: rrsult.data[j].description,
                  backImg: rrsult.data[j].icon,
                  onBackImg: rrsult.data[j].logo,
                };
                this.characteristicList.push(characteristic);
              }
            });
          }
        }
      });
    },

    onMouseenter (i) {
      this.characteristicIndex = i;
    },
    onMouseleave () {
      this.characteristicIndex = null;
    },
  },
};
</script>

<style lang="less">
.describe{
  font-size: 16px;
  color: #181818;
  line-height: 30px;
  font-family: OPPOSans-R;
  margin-bottom: 65px;
}
</style>
<style lang="less" scoped>
.bief-infroduction{
  width: 100%;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  .infroduction{
    width: 100%;
    // height: 509px;
    background: url('@/assets/about/infroduction/infroduction-canvas.png') no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    padding: 49px 0 0;
    box-sizing: border-box;
    margin-bottom: 70px;
    .infroduction-content{
      width: 940px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .title-wrap{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 38px;
        .title{
          font-size: 34px;
          color: #181818;
          line-height: 1;
          margin-bottom: 10px;
        }
        .line{
          width: 56px;
          height: 8px;
          background-color: #00b0dc;
        }
      }
      .data-list{
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .data-item{
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          .data-content{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-end;
            .data-wrap{
              display: flex;
              justify-content: flex-start;
              .data-value{
                font-size: 56px;
                font-family: OPPOSans-B;
                color: #363f4e;
                line-height: 0.9;
                margin-right: 12px;
              }
              .plus-company-wrap{
                display: flex;
                align-items: flex-end;
                justify-content: flex-start;
                .plus{
                  align-self: flex-start;
                  font-size: 40px;
                  font-family: OPPOSans-B;
                  color: #363f4e;
                  line-height: 0.6;
                }
                .company{
                  font-size: 16px;
                  color: #181818;
                  font-family: OPPOSans-R;
                  line-height: 1;
                }
              }
            }
            .data-text{
              font-size: 14px;
              color: #788190;
              font-family: OPPOSans-R;
              line-height: 1;
              margin-top: 19px;
            }
          }
        }
      }
    }
  }
  .introduce-video-wrap{
    width: 940px;
    margin: 0 auto;
    padding: 0 0 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .company-characteristic{
    width: 1200px;
    margin: 0 auto 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .title{
      font-size: 34px;
      color: #1c1c1c;
      line-height: 1;
      font-family: OPPOSans-R;
      margin-bottom: 70px;
    }
    .characteristic-wrap{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .characteristic-item{
        width: 380px;
        height: 495px;
        background-color: #fff;
        border-radius: 4px;
        border: 1px solid #eee;
        padding-top: 4px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        box-sizing: border-box;
        background-size: cover;
        background-position: center;
        transition: all 0.5s ease-in-out;
        .content-wrap{
          width: 330px;
          height: 427px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          transition: height 0.5s ease-in-out;
          .item-content{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            transform: translateY(246px);
            transition: transform 0.5s ease-in-out;
            .item-title{
              font-size: 20px;
              font-size: OPPOSans-B;
              color: #00b0dc;
              line-height: 1;
              margin-bottom: 12px;
              transition: color 0.5s ease-in-out;
            }
            .item-text{
              font-size: 16px;
              font-family: OPPOSans-R;
              color: #323232;
              line-height: 30px;
              transition: color 0.5s ease-in-out;
            }
          }
        }
      }
      .is-enter{
        box-shadow: 0px 4px 12px 0px rgba(139, 139, 139, 0.2);
        .content-wrap{
          height: 100%;
          .item-content{
            transform: translateY(60px);
            .item-title{
              color: #fff;
            }
            .item-text{
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
